export default __webpack_public_path__ + "static/media/335.b526750c.png";